export const GET_KEYWORD_SUCCEED = 'GET_KEYWORD_SUCCEED'
export const GET_KEYWORD_FAIL = 'GET_KEYWORD_FAIL'
export const GET_KEYWORD_START = 'GET_KEYWORD_START'


export const GET_EXPORT_KEYWORD_SUCCEED = 'GET_EXPORT_KEYWORD_SUCCEED'
export const GET_EXPORT_KEYWORD_FAIL = 'GET_EXPORT_KEYWORD_FAIL'
export const GET_EXPORT_KEYWORD_START = 'GET_EXPORT_KEYWORD_START'
